import React from 'react';
import t from '~t';
import { Helmet } from 'react-helmet';

import { Header } from '~co/screen/splitview/main';
import { Layout, Wrap, HeaderTitle as Title } from '~ui';

import Automatic from './automatic';
import Add from './add';
import Files from './files';
import Cloud from './cloud';

export default (props) => (
  <>
    <Helmet>
      <title>{t.s('backups')}</title>
    </Helmet>
    <Header data-fancy>
      <Title>{t.s('backups')}</Title>
    </Header>

    <Layout type='grid'>
      <Automatic {...props} />

      <Wrap className='col-span-full'>
        <Add {...props} />
        <Files {...props} />
      </Wrap>

      <Cloud {...props} />
    </Layout>
  </>
);
